import { useEffect, useState } from "react";
import changeLogFile from "./components/changeLog.md";

import Card from "@mui/material/Card";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";

// Soft UI Dashboard PRO React example components
import DashboardLayout from "LayoutContainers/DashboardLayout";
import DashboardNavbar from "components/Skill90DashboardNavbar";
import ReactMarkdown from "react-markdown";

function ChangeLog() {
  const [changeLogData, setChangeLog] = useState("");

  useEffect(() => {
    fetch(changeLogFile)
      .then((res) => res.text())
      .then((text) => setChangeLog(text));
  });

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox my={3}>
        <Card>
          <SoftBox display="flex" justifyContent="space-between" alignItems="flex-start" p={3}>
            <SoftBox lineHeight={1}>
              {/* <SoftTypography variant="h5" fontWeight="medium">
                Live Feed Integration Documentation
              </SoftTypography> */}
              {/* <SoftTypography variant="button" fontWeight="regular" color="text">
                All tools you need to calibrate the feed you want to get is in this panel.
              </SoftTypography> */}
              <div className="code-holder">
                <ReactMarkdown>{changeLogData}</ReactMarkdown>
              </div>
            </SoftBox>
          </SoftBox>
        </Card>
      </SoftBox>
    </DashboardLayout>
  );
}

// Typechecking props for the DataTable
ChangeLog.propTypes = {};

export default ChangeLog;